<template>
  <div class="report-query">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-bg">
        <div class="container">
          <h1>欢迎查询检验报告</h1>
          <p>请输入报告编号进行查询（仅限在线预览）</p>
        </div>
            </div>
          </div>

    <!-- 搜索表单 -->
    <div class="search-section">
      <div class="container">
        <el-card shadow="always" class="search-card">
          <el-form :model="searchForm" inline @submit.native.prevent="searchReports">
            <el-form-item>
              <el-input
                v-model="searchForm.report_number"
                placeholder="请输入完整的报告编号，如 HAHX2026OF0229"
                clearable
                size="large"
                class="search-input"
                @keyup.enter.native="searchReports"
              >
                <i slot="prefix" class="el-icon-document"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="large"
                @click="searchReports"
                :loading="searching"
                class="search-button"
              >
                <i class="el-icon-search"></i>
                查询报告
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>

    <!-- 搜索结果 -->
    <div class="results-section" v-if="hasSearched">
      <div class="container">
        <el-card shadow="never" class="results-card">
          <div slot="header" class="clearfix">
            <span class="company-name">陕西慧安和信检测有限公司</span>
            <div class="result-info">
              <span>查询结果</span>
              <span class="result-count">共找到 {{ pagination.total }} 条记录</span>
            </div>
          </div>
          
          <div v-loading="searching" class="results-content">
            <!-- 无结果提示 -->
            <el-empty
              v-if="!searching && reports.length === 0"
              description="未找到相关报告"
              :image-size="120"
            >
              <el-button type="primary" @click="clearSearch">重新查询</el-button>
            </el-empty>

            <!-- 结果表格 -->
            <!-- 业务要求：查询列表展示委托单位、样品编码；file_path/uploaded_by 等内部字段仍不返回 -->
            <el-table v-else :data="reports" style="width: 100%" stripe>
              <el-table-column prop="report_number" label="报告编号" width="180"></el-table-column>
              <el-table-column prop="client_unit" label="委托单位" min-width="180">
                <template slot-scope="scope">
                  {{ scope.row.client_unit || '未填写' }}
                </template>
              </el-table-column>
              <el-table-column prop="sample_name" label="样品名称" min-width="180">
                <template slot-scope="scope">
                  {{ scope.row.category_name || scope.row.sample_name || '未填写' }}
                </template>
              </el-table-column>
              <el-table-column prop="sample_code" label="样品编码" width="160">
                <template slot-scope="scope">
                  {{ scope.row.sample_code || '未填写' }}
                </template>
              </el-table-column>
              <el-table-column prop="inspection_date" label="检测日期" width="140">
                <template slot-scope="scope">
                  {{ scope.row.inspection_date ? formatDateOnly(scope.row.inspection_date) : '未填写' }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="small"
                    @click="handlePreview(scope.row)"
                  >
                    报告详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

              </div>
            </el-card>
      </div>
    </div>

    <!-- 验证码弹窗 -->
    <el-dialog
      title="请输入验证码"
      :visible.sync="verificationDialogVisible"
      width="360px"
      custom-class="verification-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="resetVerification"
    >
      <p class="verification-tip">为确保报告安全，请输入后台提供的6位验证码后再查看报告详情。</p>
      <el-form
        class="verification-form"
        :model="verificationForm"
        :rules="verificationRules"
        ref="verificationForm"
        label-width="0"
      >
        <el-form-item prop="code">
          <el-input
            v-model="verificationForm.code"
            maxlength="6"
            placeholder="输入6位数字验证码"
            size="large"
            clearable
            @keyup.enter.native="submitVerification"
          ></el-input>
        </el-form-item>
      </el-form>
      <p class="verification-tip verification-phone">
        验证码查询电话：
        <a href="tel:02986637330">029-86637330</a>
        /
        <a href="tel:17795650151">17795650151</a>
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="verificationDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="verifying" @click="submitVerification">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '../utils/request'
import config from '../config'

export default {
  name: 'ReportQuery',
  data() {
    return {
      searchForm: {
        report_number: ''
      },
      searching: false,
      hasSearched: false,
      reports: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      verificationDialogVisible: false,
      verificationForm: {
        code: ''
      },
      verificationRules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码需为6位数字', trigger: 'blur' }
        ]
      },
      verifying: false,
      pendingReport: null,
      autoQueryPending: false
    }
  },
  methods: {
    handlePreview(report) {
      this.pendingReport = report
      this.verificationForm.code = ''
      this.verificationDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.verificationForm) {
          this.$refs.verificationForm.clearValidate()
        }
      })
    },
    async submitVerification() {
      if (!this.pendingReport) return
      try {
        await this.$refs.verificationForm.validate()
      } catch (error) {
        return
      }

      this.verifying = true
      try {
        // 验证码校验（后端 /api/report-verification/validate，已限速 5 次/分钟/IP）
        await request.post('/api/report-verification/validate', {
          code: this.verificationForm.code.trim()
        })

        this.$message.success('验证通过，正在打开报告')
        this.verificationDialogVisible = false
        this.openReportPreview(this.pendingReport)
      } catch (error) {
        const status = error.response?.status
        if (status === 429) {
          const msg = error.response?.data?.message || '请求过于频繁，请稍后再试'
          this.$message.error(msg)
        } else {
          const errMsg = error.response?.data?.message || '验证码验证失败，请重试'
          this.$message.error(errMsg)
        }
      } finally {
        this.verifying = false
      }
    },
    resetVerification() {
      this.verifying = false
      this.verificationForm.code = ''
      this.pendingReport = null
    },
    updateRouteQuery(reportNumber = '') {
      const currentQuery = { ...this.$route.query }
      if (reportNumber) {
        if (currentQuery.reportNumber === reportNumber) return
        currentQuery.reportNumber = reportNumber
      } else if (currentQuery.reportNumber) {
        delete currentQuery.reportNumber
      } else {
        return
      }

      this.$router.replace({
        path: this.$route.path,
        query: currentQuery
      }).catch(() => {})
    },
    handleRouteParams() {
      const reportNumber = this.$route.query.reportNumber
      if (reportNumber && typeof reportNumber === 'string') {
        this.searchForm.report_number = reportNumber.trim()
        this.autoQueryPending = true
      }
    },
    // 搜索报告
    async searchReports() {
      const trimmed = this.searchForm.report_number.trim()
      if (!trimmed) {
        this.$message.warning('请输入报告编号')
        return
      }
      // 🔒 与后端校验对齐：至少 6 位，防止短串导致无意义查询
      if (trimmed.length < 6) {
        this.$message.warning('请输入完整的报告编号（至少 6 位）')
        return
      }

      this.searching = true
      this.hasSearched = true
      
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          report_number: this.searchForm.report_number.trim()
        }

        console.log('🔍 搜索报告，参数：', params)
        const response = await request.get(config.api.report.search, { params })
        console.log('📦 完整响应对象：', response)
        console.log('📦 响应数据：', response.data)
        
        // axios 返回的是 response 对象，数据在 response.data 中
        const res = response.data
        
        if (res.code === 200) {
          console.log('✅ 接口返回成功，code=200')
          console.log('📋 数据详情：', res.data)
          
          // 正确的数据路径：response.data.data.list
          this.reports = (res.data.list || []).map(report => ({
            ...report,
            downloading: false,
            previewing: false
          }))
          this.pagination.total = res.data.total || 0
          this.pagination.page = res.data.page || 1
          this.pagination.pageSize = res.data.pageSize || 10

          if (this.reports.length === 0) {
            this.$message.info('未找到符合条件的报告')
          } else {
            this.updateRouteQuery(this.searchForm.report_number.trim())
            this.$message.success(`找到 ${this.pagination.total} 条相关报告`)
          }
        } else {
          console.error('❌ 接口返回错误，code=', res.code, 'message=', res.message)
          this.$message.error(res.message || `查询失败（错误码：${res.code}）`)
        }
      } catch (error) {
        console.error('❌ 搜索报告异常:', error)
        console.error('错误详情:', error.response || error.message)

        // 优先展示后端返回的 message（如"请输入完整的报告编号（至少 6 位）"），其次按状态码兜底
        const backendMsg = error.response?.data?.message
        if (error.response) {
          const status = error.response.status
          if (status === 400 || status === 429) {
            // 400 校验失败 / 429 限速：完整透传后端文案
            this.$message.warning(backendMsg || (status === 429 ? '请求过于频繁，请稍后再试' : '查询参数有误'))
          } else if (status === 404) {
            this.$message.error(backendMsg || '接口不存在，请检查后端服务')
          } else if (status === 500) {
            this.$message.error(backendMsg || '服务器错误，请稍后再试')
          } else {
            this.$message.error(backendMsg || `请求失败（状态码：${status}）`)
          }
        } else if (error.request) {
          this.$message.error('无法连接到服务器，请检查网络或后端服务是否运行')
        } else {
          this.$message.error('搜索失败：' + error.message)
        }
      } finally {
        this.searching = false
      }
    },

    // ⚠️ downloadReport 方法已移除（之前是死代码，模板未调用，且引用了已下线的 config.api.report.download）
    //    报告预览/下载现统一走"输入验证码 → 校验通过 → 跳转预览页 /preview?reportNumber=xxx"流程，
    //    预览页按 report_number 直接调 /api/reports/public/preview（无 token，兼容已印发二维码）；
    //    下载由 ReportPreview.vue 内的下载按钮按 report_number 触发。



    // 预览报告 (新标签页打开，仅传报告号，兼容已印刷二维码格式)
    async openReportPreview(report) {
      if (!report.report_number) return

      try {
        const previewPageUrl = this.$router.resolve({
          name: 'ReportPreview',
          query: {
            // trim：避免后端返回的 report_number 带空格污染地址栏与生成的二维码
            reportNumber: (report.report_number || '').trim()
          }
        }).href

        window.open(previewPageUrl, '_blank')

        this.$message.success('正在新标签页中打开报告预览')
      } catch (error) {
        console.error('预览报告失败:', error)
        this.$message.error('预览失败，请稍后重试')
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    // 格式化日期（仅日期）
    formatDateOnly(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },

    // 清空搜索
    clearSearch() {
      this.searchForm = {
        report_number: ''
      }
      this.hasSearched = false
      this.reports = []
      this.pagination = {
        page: 1,
        pageSize: 10,
        total: 0
      }
      this.updateRouteQuery('')
    }
  },
  created() {
    this.handleRouteParams()
  },
  mounted() {
    if (this.autoQueryPending && this.searchForm.report_number) {
      this.autoQueryPending = false
      this.searchReports()
    }
  }
}
</script>

<style scoped>
.report-query {
  min-height: 100vh;
  background-color: #f5f7fa;
}

/* 页面头部样式 */
.page-header {
  background: linear-gradient(135deg, rgba(30, 58, 138, 0.6) 0%, rgba(59, 130, 246, 0.65) 100%), 
              url('../assets/banner2.jpg') center/cover no-repeat;
  padding: 80px 0 60px;
  position: relative;
  overflow: hidden;
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 20"><defs><radialGradient id="a" cx=".66" cy=".5" r=".6"><stop offset="0" stop-color="%23183C50"/><stop offset=".3" stop-color="%23183C50" stop-opacity=".3"/><stop offset=".8" stop-color="%23183C50" stop-opacity="0"/></radialGradient></defs><path d="M0 20h100V0c-20 0-20 20-40 20S20 0 0 0z" fill="url(%23a)"/></svg>') repeat-x;
  opacity: 0.1;
}

.header-bg {
  position: relative;
  z-index: 2;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-header h1 {
  color: white;
  font-size: 48px;
  font-weight: 300;
  margin-bottom: 15px;
  text-align: center;
}

.page-header p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  text-align: center;
  margin: 0;
}

/* 搜索区域样式 */
.search-section {
  padding: 40px 0;
  margin-top: -30px;
  position: relative;
  z-index: 3;
}

.search-card {
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12);
  border: none;
}

.search-card ::v-deep .el-card__body {
  padding: 40px;
}

.search-input {
  width: 400px;
  margin-right: 20px;
}

.search-button {
  padding: 12px 24px;
  font-weight: 500;
}

/* 结果区域样式 */
.results-section {
  padding: 0 0 60px;
}

.results-card {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: none;
}

.results-card ::v-deep .el-card__header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  padding: 20px 24px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.company-name {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

.result-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.result-count {
  color: #6c757d;
  font-size: 14px;
}

.results-content {
  padding: 24px;
  min-height: 200px;
}

/* 报告列表样式 */
.report-list {
  margin: -12px;
}

.report-item {
  margin: 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.report-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #409EFF;
}

.report-info {
  padding: 20px;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.report-number {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.report-content {
  margin-bottom: 20px;
}

.report-content p {
  margin: 8px 0;
  display: flex;
  align-items: center;
  line-height: 1.6;
  color: #495057;
}

.report-content i {
  margin-right: 8px;
  color: #6c757d;
  width: 16px;
}

.report-content strong {
  margin-right: 8px;
  color: #343a40;
}

.client-unit {
  font-size: 16px;
}

.report-title {
  font-size: 15px;
}

.report-desc {
  font-size: 14px;
  color: #6c757d;
}

.report-date {
  font-size: 13px;
  color: #868e96;
}

.report-actions {
  text-align: right;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    padding: 0 15px;
  }
  
  .search-input {
    width: 320px;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding: 60px 0 40px;
  }
  
  .page-header h1 {
    font-size: 32px;
  }
  
  .page-header p {
    font-size: 16px;
  }
  
  .search-card ::v-deep .el-card__body {
    padding: 24px;
  }
  
  .search-card ::v-deep .el-form {
    text-align: center;
  }
  
  .search-input {
    width: 100%;
    margin: 0 0 16px 0;
  }
  
  .search-button {
  width: 100%;
    margin: 0;
  }
  
  .results-content {
    padding: 16px;
  }
  
  .report-list {
    margin: -8px;
  }
  
  .report-item {
    margin: 8px;
  }
  
  .report-info {
    padding: 16px;
  }
  
  .report-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .report-number {
    font-size: 18px;
  }

  .report-actions {
    text-align: center;
  }
  }

@media (max-width: 480px) {
  .page-header h1 {
    font-size: 28px;
  }

  .report-content p {
    flex-direction: column;
    align-items: flex-start;
    margin: 12px 0;
  }
  
  .report-content i {
    margin-bottom: 4px;
  }
}

/* 加载状态优化 */
::v-deep .el-loading-mask {
  border-radius: 8px;
}

/* 空状态样式优化 */
::v-deep .el-empty {
  padding: 40px 20px;
}

::v-deep .el-empty__description {
  margin: 20px 0;
}

/* 表单项间距优化 */
::v-deep .el-form-item {
  margin-bottom: 0;
  margin-right: 0;
}

/* 标签样式 */
::v-deep .el-tag {
  border-radius: 12px;
  padding: 4px 12px;
  font-size: 12px;
}

/* 按钮样式优化 */
::v-deep .el-button {
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

::v-deep .el-button--primary {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border: none;
}

::v-deep .el-button--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

::v-deep .el-button--success {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  border: none;
}

::v-deep .el-button--success:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.4);
}


/* 报告操作按钮间距优化 */
.report-actions .el-button {
  margin-left: 8px;
}

.report-actions .el-button:first-child {
  margin-left: 0;
}

/* 验证码弹窗样式 */
.verification-dialog {
  max-width: 420px;
}

.verification-form {
  margin: 16px 0 24px;
}

.verification-tip {
  line-height: 1.6;
  margin-bottom: 8px;
  color: #606266;
}

.verification-phone {
  margin-top: 16px;
  font-weight: 600;
  color: #d93025;
}

.verification-phone a {
  color: #d93025;
  font-weight: 600;
  text-decoration: none;
}

.verification-phone a:hover {
  text-decoration: underline;
}

@media (max-width: 480px) {
  .verification-dialog {
    width: 92% !important;
  }
}
</style> 